import { v4 as uuidv4 } from "uuid";

import ReactDOM from "react-dom";
import { makeAutoObservable, reaction } from "mobx";
import { observer } from "mobx-react-lite";
import FoodOption from "./FoodOption";

class Meal {
  foodOptions = [];

  isSelected = false;

  isShowingFoods = true;

  constructor(
    id = uuidv4(),
    name = "",
    notes = "",
    order = 0,
    defaultFoodOption = 0,
    nutritionPlan = null
  ) {
    this.id = id;
    this.name = name;
    this.notes = notes;
    this.defaultFoodOption = defaultFoodOption;
    this.order = order;
    this.nutritionPlan = nutritionPlan;
    makeAutoObservable(this);
  }

  uploadToCloud() {
    let foodOptionsArray = this.foodOptions.map((foodOption) =>
      foodOption.uploadToCloud()
    );

    return {
      id: this.id.toString().toLowerCase(),
      name: this.name,
      notes: this.notes,
      order: this.order,
      default_food_option: this.defaultFoodOption,
      food_options: foodOptionsArray,
    };
  }

  fetchFoodOption(foodOptionData) {
    const newFoodOption = new FoodOption(
      foodOptionData.id,
      foodOptionData.order,
      this
    );

    foodOptionData?.foods.forEach((food) => {
      newFoodOption.fetchFood(food);
    });

    this.foodOptions.push(newFoodOption);
  }

  get getDefaultFoodOption() {
    return this.foodOptions.find(
      (foodOption) => foodOption.order === this.defaultFoodOption
    );
  }

  get sortedFoodOptions() {
    return this.foodOptions.slice().sort((a, b) => a.order - b.order);
  }

  addFoodOption() {
    const maxOrder = this.foodOptions.length
      ? Math.max(...this.foodOptions.map((f) => f.order))
      : -1;
    const newOrder = maxOrder + 1;

    const newFoodOption = new FoodOption(uuidv4(), newOrder, this);

    this.foodOptions.push(newFoodOption);
  }

  deleteDefaultFoodOption() {
    this.foodOptions = this.foodOptions
      .filter((fo) => fo.id !== this.getDefaultFoodOption.id)
      .map((fo, i) => {
        fo.order = i;
        return fo;
      });

    if (this.defaultFoodOption > 0) {
      this.defaultFoodOption -= 1;
    }
  }

  get canDisplayFoodOptionsRow() {
    const defaultOpt = this.getDefaultFoodOption;
    return this.foodOptions.length !== 1 || defaultOpt?.foods?.length > 0;
  }

  get selectedFoodOption() {
    return this.foodOptions.find((foodOption) => foodOption.isSelected);
  }

  setSelectedFoodOption(selectedFoodOption) {
    this.foodOptions.forEach((foodOption) => {
      if (foodOption.id === selectedFoodOption.id) {
        foodOption.setProperty("isSelected", true);
      } else {
        foodOption.setProperty("isSelected", false);
      }
    });
  }

  // Generic setter
  setProperty(propertyName, value) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      this[propertyName] = value;
    } else {
      console.error(`Property ${propertyName} does not exist.`);
    }
  }

  // Generic getter
  getProperty(propertyName) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      return this[propertyName];
    } else {
      console.error(`Property ${propertyName} does not exist.`);
      return undefined;
    }
  }
}
export default Meal;
